export const ToastAutoClose = 1500 //milliseconds
